import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../shared/locales/no.json';

export default class extends Component {
    static propTypes = {
        reorderImages: PropTypes.func.isRequired,
        onDeleteClick: PropTypes.func.isRequired,
        imageIndex: PropTypes.number.isRequired,
    };

    onReorderClicked(leftOrRight, e) {
        e.preventDefault();
        this.props.reorderImages(leftOrRight, this.props.imageIndex);
    }

    render() {
        return (
            <React.Fragment>
                <button
                    className="button button--flat"
                    onClick={this.onReorderClicked.bind(this, 'left')}
                    title="Flytt venstre"
                    type="button"
                >
                    &larr;
                </button>
                <button
                    className="button button--flat"
                    onClick={this.onReorderClicked.bind(this, 'right')}
                    title="Flytt høyere"
                    type="button"
                >
                    &rarr;
                </button>
                <span className="u-float-right">
                    <button
                        className="button button--destructive-flat"
                        onClick={this.props.onDeleteClick}
                        type="button"
                    >
                        {i18n.images.remove}
                    </button>
                </span>
            </React.Fragment>
        );
    }
}
